import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import EmployeesFilter from './EmployeesFilter';
import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';

function EmployeesDepartmentFilterSuperuser() {
	const { t } = useTranslation();

	const query = graphql.useGroupsQuery({
		variables: {
			first: 1000,
			filter: {
				types: [graphql.GroupType.Department],
			},
		},
	});

	return (
		<EmployeesFilter
			name="groupIDs"
			label={t('employees.filters.department.label')}
			options={
				query.data?.groups.edges.map((edge) => ({
					label: edge.node.name,
					value: edge.node.id,
				})) ?? []
			}
		/>
	);
}

function EmployeesDepartmentFilterManager() {
	const { t } = useTranslation();

	const query = graphql.useViewerDepartmentsQuery();

	const roleTypes = new Set([
		graphql.RoleType.PrimaryManager,
		graphql.RoleType.CollaborativeManager,
		graphql.RoleType.Owner,
	]);

	return (
		<EmployeesFilter
			name="groupIDs"
			label={t('employees.filters.department.label')}
			options={
				query.data?.viewer.roles
					.filter(({ role }) => roleTypes.has(role.type))
					.map(({ targetV2 }) => targetV2 as graphql.Group)
					.filter((group) => !!group?.__typename)
					.filter(({ __typename }) => __typename === 'Group')
					.map((group) => ({
						label: group!.name,
						value: group!.id,
					})) ?? []
			}
		/>
	);
}

export default function EmployeesDepartmentFilter() {
	const roles = useViewerRoles();

	if (roles.isWorkspaceSuperuser) {
		return <EmployeesDepartmentFilterSuperuser />;
	} else {
		return <EmployeesDepartmentFilterManager />;
	}
}
